import React from 'react'
import { ActiveEl, BackgroundEl } from './elements'
import Headers from './components/headers'
import RecordedCourseDashboardStore from '../../../../stores/RecordedCourseDashboardStore'
import { tabs } from './config'
import { spring } from '../../config/animation'
import { Switch, withRouter } from 'react-router-dom'
import Route from '../../../../../../../../../Components/Router/Route'

const Tabs = ({ match: { path } }) => {
  const { expanded, active } = RecordedCourseDashboardStore.useContainer()

  return (
    <Switch>
      <Route
        path={`${path}/:tab?`}
        render={() => (
          <>
            {!expanded && <BackgroundEl />}
            <Headers />
            <ActiveEl layout transition={spring} key={`active-tab-${active}`}>
              {tabs[active].component}
            </ActiveEl>
          </>
        )}
      />
    </Switch>
  )
}

export default withRouter(Tabs)
